import React from 'react';

// Assets
import timedoutFile from '@/images/design-system-v2/loading-state/timedout-file.png';

// Components
import { FormattedMessageV2 } from '@/views/components/i18n';

const TimeoutStep: React.FC = () => {
  const i18nBasePath = 'ProcessingFile';

  return (
    <div className="timeout-step">
      <img className="image" src={timedoutFile} alt="timed-out-file" />
      <FormattedMessageV2 className="title" toLocalize={`${i18nBasePath}.TimeoutStep.Title`} />
      <FormattedMessageV2 className="subtitle" toLocalize={`${i18nBasePath}.TimeoutStep.Body`} />
      <FormattedMessageV2 className="disclosure" toLocalize={`${i18nBasePath}.Disclosure`} />
    </div>
  );
};

export default TimeoutStep;
